import 'react-tooltip/dist/react-tooltip.css';

const { render } = wp.element; //we are using wp.element here!
import AppStepForm from './AppStepForm';
import AppDxfForm from './AppDxfForm';
import AppDxfFormModal from './AppDxfForm';
if (document.getElementById('hjt-step-form')) { //check if element exists before rendering
  let mid = document.getElementById('hjt-step-form').getAttribute('mid');
  render(<AppStepForm mid={mid} />, document.getElementById('hjt-step-form'));
}
if (document.getElementById('hjt-step-form-modal')) { //check if element exists before rendering
  let mid = document.getElementById('hjt-step-form-modal').getAttribute('mid');
  render(<AppStepForm mid={mid} mode="modal" />, document.getElementById('hjt-step-form-modal'));
}
if (document.getElementById('hjt-dxf-form-modal')) { //check if element exists before rendering
  let mid = document.getElementById('hjt-dxf-form-modal').getAttribute('mid');
  render(<AppDxfFormModal mode="modal" />, document.getElementById('hjt-dxf-form-modal'));
}
if (document.getElementById('hjt-dxf-form')) { //check if element exists before rendering
  render(<AppDxfForm mode="toto" />, document.getElementById('hjt-dxf-form'));
}